export const messages = {
  en: {
    userDetailGroupOrders: {
      orderId: 'Order ID',
      productImage: 'Product Image',
      productName: 'Product Name',
      buyer: 'Buyer',
      groupLeader: 'Group Leader',
      buyQuantity: 'Purchase Quantity',
      groupPeople: 'Group People',
      peopleGroup: 'People Group',
      groupAmount: 'Group Amount',
      status: 'Status',
      rebateAmount: 'Rebate Amount',
      openTime: 'Open Time',
      groupTime: 'Group Time',
      deadline: 'Deadline'
    }
  },
  zh: {
    userDetailGroupOrders: {
      orderId: '订单ID',
      productImage: '商品图片',
      productName: '商品名称',
      buyer: '购买者',
      groupLeader: '团长',
      buyQuantity: '购买数量',
      groupPeople: '拼团人数',
      peopleGroup: '人团',
      groupAmount: '拼团金额',
      status: '状态',
      rebateAmount: '返佣金额',
      openTime: '开团时间',
      groupTime: '拼团时间',
      deadline: '截止时间'
    }
  }
}